import { Box } from '@chakra-ui/react';
import React from 'react';

import { Typography } from '~/packages/common-frontend/components/Typography';
import { useCreditFacilityContext } from '~/packages/credit-facility/hooks/CreditFacilityProvider';
import { PortfolioLtvChartTemplateForCreditFacility } from '~/packages/portfolio/ui/risk/PortfolioLtvChartTemplateForCreditFacility';

type BorrowerLtvContainerProps = { organizationId: string };
export const BorrowerLtvContainer = ({
  organizationId,
}: BorrowerLtvContainerProps) => {
  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <Box height="100%">
      <Typography variant="section-title">LTV</Typography>
      <PortfolioLtvChartTemplateForCreditFacility
        organizationId={organizationId}
        creditFacilityId={creditFacilityId}
      />
    </Box>
  );
};
